import type { IconNode } from '../types';

/**
 * @name locate-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHg9IjUiIHk9IjUiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0xMiA1VjIiIC8+CiAgPHBhdGggZD0iTTE5IDEyaDMiIC8+CiAgPHBhdGggZD0iTTEyIDIydi0zIiAvPgogIDxwYXRoIGQ9Ik0yIDEyaDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/locate-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const locateSquare: IconNode = [
  ['rect', { width: '14', height: '14', x: '5', y: '5', rx: '2', key: '1nfitv' }],
  ['path', { d: 'M12 5V2', key: '116dvj' }],
  ['path', { d: 'M19 12h3', key: 'osuazr' }],
  ['path', { d: 'M12 22v-3', key: 'kmzjlo' }],
  ['path', { d: 'M2 12h3', key: '1wrr53' }],
];

export default locateSquare;
